import { render, staticRenderFns } from "./SerieTreatmentModal.vue?vue&type=template&id=289733f4"
import script from "./SerieTreatmentModal.vue?vue&type=script&lang=js"
export * from "./SerieTreatmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports